import { Box } from '@mui/material';
import { DeckPlan } from '@/components/Analysis/DeckPlan';
import { DefaultLayout } from '@/layouts';
import { useFetchCookies, useRouter } from '@/hooks';
import { PageLoader } from '@/components/shared/PageLoader';

export const DeckPlanPage = () => {
  const router = useRouter();
  const { inspection } = router.query;
  const cookiesFetched = useFetchCookies();

  if (!inspection || Array.isArray(inspection)) {
    return <div>Please specify inspection id</div>;
  }

  if (!cookiesFetched) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  return (
    <DefaultLayout variant="analysis">
      <DeckPlan inspectionId={inspection} />
    </DefaultLayout>
  );
};

